module.exports = __webpack_public_path__ + "img/cheque.e2183e8c.svg";